import React from 'react';
import { PrismicRichText } from "@prismicio/react";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";


export const AccordionLayout = (props) => {

    const sc = props.slice.primary;

    const accord = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }


    return (
        <section className={"accordion bg-" + (bg) + " " + (space)}>
            <div className="wrapper">
                <div className="w-auto">
                    <div className="mb-8"><PrismicRichText field={sc.section_title.richText} /></div>
                    <PrismicRichText field={sc.section_content.richText} components={components} />
                    
                        {accord.map((item, index) => {
                            
                            return (
                                <Accordion key={index} className="accord article" transition transitionTimeout={250} >
                                    <AccordionItem header={item.content_title.text} {...(item.open ? { initialEntered: true } : {})}>
                                        <div className="con">
                                        <PrismicRichText field={item.content.richText} components={components} />
                                        </div>
                                    </AccordionItem>
                                </Accordion>
                            )
                        })}
                </div>
                
            </div>
        </section>
    );
}

